// This module must be imported before any other module that defines Zod schemas.
// Zod 4 uses JIT compilation (via new Function()) by default, which triggers
// CSP unsafe-eval violations. Disabling JIT here prevents the probe from firing
// during schema registration.
// Tracking resolution in https://github.com/colinhacks/zod/issues/5789
import { z } from "zod";

z.config({ jitless: true });
